export enum VoiceDictationResultAction {
	Initializing = 'Initializing',
	Uninitialized = 'Uninitialized',
	Unsupported = 'Unsupported',
	Recording = 'Recording',
	Stopped = 'Stopped',
	Error = 'Error',
}

export type VoiceDictationState =
	| {
			action: VoiceDictationResultAction.Uninitialized;
			error?: string;
			transcription: null;
	  }
	| {
			action: VoiceDictationResultAction.Initializing;
			error?: string;
			transcription: null;
	  }
	| {
			action: VoiceDictationResultAction.Unsupported;
			error: string;
			transcription: null;
	  }
	| {
			action: VoiceDictationResultAction.Recording;
			error?: string;
			transcription: string;
	  }
	| {
			action: VoiceDictationResultAction.Stopped;
			error?: string;
			transcription: string | null;
	  }
	| {
			action: VoiceDictationResultAction.Error;
			error: string;
			transcription: string | null;
	  };

type VoiceDictationAction =
	| { type: 'SET_STATE'; payload: VoiceDictationState }
	| { type: 'SET_INITIALIZING' }
	| { type: 'SET_RECORDING'; payload: { transcription: string } }
	| { type: 'SET_STOPPED' }
	| { type: 'SET_ERROR'; payload: { error: string; transcription?: string | null } }
	| { type: 'UPDATE_TRANSCRIPTION'; payload: { nextTranscription: string } };

export const voiceDictationReducer = (
	state: VoiceDictationState,
	action: VoiceDictationAction,
): VoiceDictationState => {
	switch (action.type) {
		case 'SET_INITIALIZING':
			return {
				action: VoiceDictationResultAction.Initializing,
				transcription: null,
			};
		case 'SET_RECORDING':
			return {
				action: VoiceDictationResultAction.Recording,
				transcription: action.payload.transcription,
			};
		case 'SET_STOPPED':
			return {
				...state,
				action: VoiceDictationResultAction.Stopped,
			};
		case 'SET_ERROR':
			return {
				action: VoiceDictationResultAction.Error,
				error: action.payload.error,
				transcription: action.payload.transcription ?? null,
			};
		case 'UPDATE_TRANSCRIPTION':
			if (
				state.action === VoiceDictationResultAction.Recording ||
				state.action === VoiceDictationResultAction.Stopped
			) {
				const transcription = state.transcription
					? state.transcription + action.payload.nextTranscription
					: action.payload.nextTranscription;
				return {
					...state,
					transcription,
				};
			}
			return state;
		default:
			return state;
	}
};
